export default __webpack_public_path__ + "static/IP_Vision_Pro_06-8003bcf2d3dcd1fd6b38791d9d783324.webp";